import { LegalPage } from "@/components/LegalPage";

const SECTIONS = [
  {
    body: `The orders for the user are shipped through registered domestic courier companies and/or speed post only. Orders are shipped within 1 day from the date of the order and/or payment, or as per the delivery date agreed at the time of order confirmation and delivering of the shipment, subject to courier company / post office norms.`,
  },
  {
    body: `Platform Owner shall not be liable for any delay in delivery by the courier company / postal authority. Delivery of all orders will be made to the address provided by the buyer at the time of purchase.`,
  },
  {
    body: `Delivery of our services will be confirmed on your email ID as specified at the time of registration. If there are any shipping cost(s) levied by the seller or the Platform Owner (as the case may be), the same is not refundable.`,
  },
];

export default function Shipping() {
  return (
    <LegalPage
      title="Shipping Policy"
      sections={SECTIONS}
      testid="shipping-page"
    />
  );
}
